"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const constants_1 = require("modules/configManager/constants");
const AnalyticsScriptDescription = () => {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_my-2 _text-gray-400", children: [t('config_manager.config_data.analytics_integration_v2.description', {
                data: { format: constants_1.ANALYTICS_SCRIPT_FORMAT_V4 }
            }), ' ', (0, jsx_runtime_1.jsx)("a", { href: constants_1.ANALYTICS_SCRIPT_FIND_ID_LINK, rel: "noreferrer noopener", target: "_blank", children: t('config_manager.config_data.analytics_integration_v2.description_link') }), '.'] }));
};
exports.default = AnalyticsScriptDescription;
